import { useQuery } from 'react-query';
import { UICourse } from '../../../../../packages/types/src/course';
import { getAllCourses, getBlockItems, getPublishedItems } from '../../apis/V2/course';
import { UIPublishedItem } from '../../../../../packages/types/src/publishedItem';

export const useAllCourses = () => {
	return useQuery({
		queryKey: ['getAllCourses'],
		queryFn: async () => (await getAllCourses()).data?.data as UICourse[],
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
	});
};

export const usePublishedItems = (courseId?: string) => {
	console.log('courseId:', courseId);
	return useQuery({
		queryKey: ['getPublishedItems', courseId],
		queryFn: async () => (await getPublishedItems({ courseId })).data.publishedItems as UIPublishedItem[],
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!courseId,
	});
};

export const useBlockItems = (blockId?: string, blockItemType?: string) => {
	return useQuery({
		queryKey: ['getBlockItems', blockId],
		queryFn: async () => (await getBlockItems({ blockID: blockId, type: blockItemType })).data?.filteredBlockItems,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!blockId,
	});
};
